<template lang="pug">
.online-reservation-setting-tab(v-cloak)
  .register-body.mt-4
    .d-flex.flex-wrap(style="width:100%;")
      //- 予約時間単位
      FormInputUnit(v-model="unit" style="max-width:280px; width:280px;")
      .d-flex.flex-row-reverse.flex-fill
        button.btn.example-btn(@click="onExampleModal" type="button") 設定例
    //- 家族ユーザーの予約可能日
    FormInputAvailableDate(v-model="availableDate")
    //- 家族ユーザーへの面会スケジュールの公開予約
    FormInputRadio(v-model="usePublishSchedule" key-name="家族ユーザーへの面会スケジュールの公開予約" name="use-publish-schedule-online"
      :options="_usePublishScheduleOptions" :validation-rules="{ required: true }" required)
        template(v-slot:question)
          HelpIcon(popoverId="use-publish-schedule-online-help-text" title="家族ユーザーへの面会スケジュールの公開予約について")
            template(v-slot:text)
              div
                strong 使用しない
                span の場合は面会スケジュールの登録後すぐにご家族がスケジュールを見られます。
                br
                strong 使用する
                span の場合は面会スケジュールの登録後すぐにご家族はスケジュールを見られず、次に設定いただく公開予約日時後に見られるようになります。
    //- 面会スケジュールの公開予約日時
    InputPublishDatetime(v-if="usePublishSchedule == true" v-model="publishDatetime" name="use-publish-datetime-online")
      template(v-slot:question)
        HelpIcon(popoverId="use-publish-datetime-online-help-text" title="面会スケジュールの公開予約日時について")
          template(v-slot:text)
            div
              span 面会スケジュールが登録されていても、公開予約日時以降にならないとご家族は面会スケジュールを見られません。
              br
              span 事前に面会スケジュールを登録して、指定した公開日時にご家族にご案内したい場合などにご利用ください。
              br
              br
              span 例（25日の10時に設定した場合）
              br
              span 7月の面会スケジュールを6月25日の10時に公開します。
    //- 面会スケジュールの単位
    FormInputGroupUseType(v-model="groupUseType" :active="1 <= planType")
      template(v-slot:question)
        HelpIcon(popoverId="form-input-group-use-online-help" title="面会スケジュールの単位について")
          template(v-slot:text)
            span
              strong 利用者グループ（例えばフロア）
              span を選択した場合、
              strong 利用者グループ
              span ごとにオンライン面会スケジュールを設定することができます。
            br
            span
              span 利用者グループ設定を使用する為には、利用者画面の
              strong グループ設定
              span で利用者グループを作成し、グループの所属利用者を設定する必要があります。
            br
            br
            span
              strong 施設全体
              span を選択した場合、
              span 施設全体で１つのオンライン面会スケジュールを設定します。
    //- 予約可能数のカウント範囲
    FormInputReservationCountType(v-model="countType" :active="useGroup && 1 <= planType")
      template(v-slot:question)
        HelpIcon(popoverId="form-input-count-type-online-help" title="予約可能数のカウント範囲について")
          template(v-slot:text)
            span
              span 予約枠あたりの予約数を
              strong 施設全体
              span でカウントするか、
              strong 同一利用者グループ内
              span のみでカウントするかを設定できます。
            br
            br
            span
              strong 施設全体
              span ：全ての利用者グループの予約数を合算し、その予約数が予約可能数に達すると予約できなくなります。
            br
            span
              strong 同一利用者グループ内
              span ：利用者グループ単位の予約数が予約可能数に達すると、その利用者グループの予約はできなくなります。
    //- 予約枠あたりの予約可能数
    FormInputReservationPerCounts(v-model="reservationPerCounts")
      template(v-slot:question)
        HelpIcon(popoverId="form-input-per-counts-online-help" title="予約枠あたりの予約可能数について")
          template(v-slot:text)
            span １つの予約時間枠に予約可能な上限数を設定できます。
            br
            span ただし上限数に達していない場合でも、同一予約時間枠に同じ利用者のご家族が予約している場合は予約できません。
            span また、同一予約時間枠に同じ利用者のご家族が訪問面会予約している場合も予約できません。
    //- 利用者ごとの予約間隔制限
    FormInputIntervalLimit(v-model="intervalLimit")
      template(v-slot:question)
        HelpIcon(popoverId="form-input-interval-online-help" title="利用者ごとの予約間隔制限について")
          template(v-slot:text)
            span
              strong 利用者の家族単位
              span でオンライン面会予約の
              strong 間隔を制限
              span することができます。
            br
            br
            span
              span 例えば東京花子様という利用者に東京太郎様と東京次郎様という２名の家族が登録している場合、東京太郎様が面会予約すると、東京次郎様も東京太郎様と同じ予約間隔制限を受けます。
    //- 利用者ごとの同月内の予約可能な面会数
    FormInputVisitsLimitOfMonth(v-model="visitsLimitOfMonth")
      template(v-slot:question)
        HelpIcon(popoverId="form-input-visits-limit-of-month-online-help" title="利用者ごとの同月内の予約可能な面会数について")
          template(v-slot:text)
            span
              strong 利用者の家族単位
              span でオンライン面会予約の
              strong 同月内の面会数を制限
              span することができます。
            br
            br
            span
              span 例えば東京花子様という利用者に東京太郎様と東京次郎様という２名の家族が登録している場合、東京太郎様が面会予約すると、東京次郎様も東京太郎様と同じ同月内面会数制限を受けます。
    //- 利用者ごとの同時に予約可能な面会数
    FormInputConcurrentNumberLimit(v-model="concurrentNumberLimit")
      template(v-slot:question)
        HelpIcon(popoverId="form-input-concurrent-online-help" title="利用者ごとの同時に予約可能な面会数について")
          template(v-slot:text)
            span
              span 利用者の家族単位で
              strong 同時に予約可能な面会数
              span を制限することができます。
            br
            span
              strong 面会終了後にならないと次の予約が出来ない
              span ようにすることもできます
    //- 利用者ごとの同時に予約可能な面会数の家族ユーザー表示
    FormInputRadio(v-model="showConcurrentNumberLimit" key-name="同時に予約可能な面会数の家族ユーザー表示" name="online-showConcurrentNumberLimit"
      :options="showConcurrentNumberLimitOptions" :validation-rules="{ required: true }" required)
        template(v-slot:question)
          HelpIcon(popoverId="showConcurrentNumberLimit-online-help" title="同時に予約可能な面会数の家族ユーザー表示について")
            template(v-slot:text)
              div 家族ユーザーの面会予約ページに「同時に予約可能な回数」を表示するかどうかを選択できます。
    //- 利用者ごとの予約制限の確認対象
    FormInputReservationLimitType(v-model="limitType" :reservationType="1")
      template(v-slot:question)
        HelpIcon(popoverId="form-input-limit-type-online-help" title="利用者ごとの予約制限の確認対象について")
          template(v-slot:text)
            strong 利用者ごとの予約間隔制限
            span と
            strong 利用者ごとの同時に予約可能な面会数
            span の
            strong 確認対象の面会予約
            span を選択できます。
    //- 自動承諾
    FormInputReservationAutoApproval(v-model="autoApproval" name="reservation-auto-approval-online")
      template(v-slot:question)
        HelpIcon(popoverId="form-input-auto-approval-online-help" title="自動承諾について")
          template(v-slot:text)
            span
              span 自動承諾に設定すると、家族ユーザーからの予約申込時にシステムで自動的に承諾にします。
    //- 家族ユーザーへの連絡事項
    FormTextarea(key-name="家族ユーザーへの連絡事項" name="description" v-model="description" placeholder="例：毎月中旬頃に翌月の面会スケジュールを公開いたします。多くのご家族が面会できるように、ご家族ごとに2週間間隔の面会予約制限を設けております。"
      :validation-rules="{ max: 1000 }" :maxlength="1000" :styles="{ maxWidth: '700px', width: '700px', minHeight: '160px' }")
      template(v-slot:question)
        HelpIcon(popoverId="form-textarea-description-online-help" title="家族ユーザーへの連絡事項について")
          template(v-slot:text)
            span 入力内容は、ご家族のオンライン面会予約の申込みページに「施設からの連絡事項」として表示されます。
    //- 家族からの連絡の使用可否
    FormInputUseText(v-model="useText" name="online-reservation-use-text")
    //- 家族ユーザーからの面会予約の受付中もしくは停止中
    FormInputCanReservation(v-model="canReservation")

    .register-row(v-show="errorMessage")
      .register-group
        .register-value
          .error-message {{ errorMessage }}

  .box-footer.register-footer
    ValidationAlert(v-model="showValidationAlert")
    .buttons.m-0
      button.btn.update-btn(@click="showConfirmUpdateModal" type="button") 更新
      button.btn.cancel-btn(@click="gotoReservationList" type="button") キャンセル

  OkCancelModal(v-model="showUpdateModal" title="オンライン面会の基本設定を更新しますか？" @ok="updateFacility")
  OkModal(v-model="showUpdateSuccessModal" title="更新に成功しました。" @ok="gotoReservationList")
  OnlineReservationSettingExampleModal(ref="onlineReservationSettingExampleModal")

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Watch, Inject, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";

import CustomValidate from "@/commons/utils/CustomValidate";
import { PcUrl } from "@/commons/constants/PcUrl";
import OnlineReservationSettingsService, {
  OnlineReservationSettingsGetModel,
  OnlineReservationSettingsPatchModel,
  GroupUseType,
  CountType,
  LimitType,
  VisitsLimitOfMonth,
  ReservationUnit,
  AvailableDate,
  ReservationPerCounts,
  IntervalLimit,
  ConcurrentNumberLimit,
  PublishDatetime
} from "@/commons/services/OnlineReservationSettings";
import SystemError from "@/commons/models/SystemError";
import { PlanType } from "@/commons/services/Plans";

import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import FormInputUnit from "@/pc/components/reservations/FormInputUnit.vue";
import FormInputAvailableDate from "@/pc/components/reservations/FormInputAvailableDate.vue";
import FormInputReservationPerCounts from "@/pc/components/reservations/FormInputReservationPerCounts.vue";
import FormInputReservationCountType from "@/pc/components/reservations/FormInputReservationCountType.vue";
import FormInputIntervalLimit from "@/pc/components/reservations/FormInputIntervalLimit.vue";
import FormInputVisitsLimitOfMonth from "@/pc/components/reservations/FormInputVisitsLimitOfMonth.vue";
import FormInputConcurrentNumberLimit from "@/pc/components/reservations/FormInputConcurrentNumberLimit.vue";
import FormInputReservationLimitType from "@/pc/components/reservations/FormInputReservationLimitType.vue";
import FormInputCanReservation from "@/pc/components/reservations/FormInputCanReservation.vue";
import FormInputGroupUseType from "@/pc/components/reservations/FormInputGroupUseType.vue";
import FormInputReservationAutoApproval from "@/pc/components/reservations/FormInputReservationAutoApproval.vue";
import FormInputUseText from "@/pc/components/reservations/FormInputUseText.vue";
import InputPublishDatetime from "@/pc/components/reservations/InputPublishDatetime.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import OnlineReservationSettingExampleModal from "@/pc/components/modals/OnlineReservationSettingExampleModal.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";
import FormInputRadio from "@/pc/components/forms/FormInputRadio.vue";

/**
 * オンライン面会設定コンポーネント
 */
@Component({
  components: {
    FormInputUnit,
    FormInputAvailableDate,
    FormInputReservationPerCounts,
    FormInputReservationCountType,
    FormInputIntervalLimit,
    FormInputVisitsLimitOfMonth,
    FormInputConcurrentNumberLimit,
    FormInputReservationLimitType,
    FormInputCanReservation,
    FormInputGroupUseType,
    FormInputReservationAutoApproval,
    FormInputUseText,
    InputPublishDatetime,
    OkCancelModal,
    OkModal,
    HelpIcon,
    PageLoading,
    ValidationAlert,
    OnlineReservationSettingExampleModal,
    FormTextarea,
    FormInputRadio
  },
  $_veeValidate: { validator: "new" }
})
export default class OnlineReservationSettingTab extends Vue {
  /** オンライン面会設定サービス */
  @Inject("OnlineReservationSettingsService") onlineReservationSettingsService!: OnlineReservationSettingsService;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** 更新確認モーダル表示可否 */
  showUpdateModal: boolean = false;
  /** 更新完了モーダル表示可否 */
  showUpdateSuccessModal: boolean = false;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** プラン種別 */
  planType: PlanType = PlanType.UNKNOWN;

  /** 単位 */
  unit: ReservationUnit = ReservationUnit.FIFTEEN_MINUTES;
  /** 何日前まで予約できるか */
  availableDate: AvailableDate = AvailableDate.TODAY;
  /** 予約枠あたりの予約可能数 */
  reservationPerCounts: ReservationPerCounts = ReservationPerCounts.ONE;
  /** 予約可能数のカウント範囲 */
  countType: CountType = CountType.GROUP;
  /** 利用者ごとの予約間隔制限 */
  intervalLimit: IntervalLimit = IntervalLimit.NO_LIMIT;
  /** 利用者ごとの同月内の予約可能な面会数 */
  visitsLimitOfMonth: VisitsLimitOfMonth = VisitsLimitOfMonth.NO_LIMIT;
  /** 利用者ごとの同時に予約可能な面会数 */
  concurrentNumberLimit: ConcurrentNumberLimit = ConcurrentNumberLimit.NO_LIMIT;
  /** 利用者ごとの同時に予約可能な面会数の家族ユーザー表示 */
  showConcurrentNumberLimit: boolean = false;
  /** 利用者ごとの同時に予約可能な面会数の家族ユーザー表示の選択肢 */
  showConcurrentNumberLimitOptions: Array<{ value: boolean; label: string }> = [
    { value: true, label: "表示する" },
    { value: false, label: "表示しない" }
  ];
  /** 利用者ごとの予約制限の確認対象 */
  limitType: LimitType = LimitType.SEPARATE;
  /** 家族ユーザーからの面会予約の受付中もしくは停止中 */
  canReservation: boolean = false;
  /** 家族ユーザーへの面会スケジュールの公開予約機能を使用するか */
  usePublishSchedule: boolean = false;
  /** 面会スケジュールの公開予約日時 */
  publishDatetime: PublishDatetime | null = null;
  /** 面会スケジュールの単位 */
  groupUseType: GroupUseType = GroupUseType.DISUSE;
  /** 利用者グループ使用か否か */
  useGroup: boolean = false;
  /** 自動承諾を使用するか否か */
  autoApproval: boolean = false;
  /** 家族ユーザーへの案内 */
  description: string | null = null;
  /** 家族からの連絡の使用可否 */
  useText: boolean = false;
  /** 更新日時 */
  updated: number = 0;
  /** エラーメッセージ */
  errorMessage: string = "";

  get _usePublishScheduleOptions(): Array<{ value: boolean; label: string }> {
    return [
      { value: false, label: "使用しない" },
      { value: true, label: "使用する" }
    ];
  }

  /**
   * ### 利用者グループ使用有無の値監視
   *
   * - 利用者グループ使用有無に応じて利用者グループ使用か否かを更新する
   */
  @Watch("groupUseType")
  public changeGroupUseType(newValue: GroupUseType): void {
    if (newValue == GroupUseType.DISUSE) {
      this.useGroup = false;
    } else if (newValue == GroupUseType.USE) {
      this.useGroup = true;
    } else {
      this.useGroup = false;
    }
    return;
  }

  /**
   * ### vue lifecycle created
   */
  public created() {
    CustomValidate.addCustomValidate(this.$validator);

    return;
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    this.planType = userStore.facility.planType;

    await this.createView();

    this.isBusy = false;

    return;
  }

  /**
   * ### 画面表示情報を作成する
   */
  public async createView(): Promise<void> {
    const setting: OnlineReservationSettingsGetModel = await this.getOnlineReservationSetting();

    // 編集してAPIにPATCHメソッドで渡すので、値は個別に保持する
    this.unit = setting.unit;
    this.availableDate = setting.availableDate;
    this.reservationPerCounts = setting.reservationPerCounts;
    this.countType = setting.countType;
    this.intervalLimit = setting.intervalLimit;
    this.visitsLimitOfMonth = setting.visitsLimitOfMonth;
    this.concurrentNumberLimit = setting.concurrentNumberLimit;
    this.showConcurrentNumberLimit = setting.showConcurrentNumberLimit;
    this.limitType = setting.limitType;
    this.canReservation = setting.canReservation;
    this.groupUseType = setting.groupUseType;
    this.usePublishSchedule = setting.usePublishSchedule;
    // 値が無い場合は初期値を格納する
    if (!setting.publishDatetime) {
      this.publishDatetime = {
        date: 1,
        hour: 0
      };
    } else {
      this.publishDatetime = setting.publishDatetime;
    }
    this.autoApproval = setting.autoApproval;
    this.description = setting.description;
    this.useText = setting.useText;
    this.updated = setting.updated;

    return;
  }

  /**
   * ### オンライン面会設定取得
   */
  public async getOnlineReservationSetting(): Promise<OnlineReservationSettingsGetModel> {
    // API呼び出しして施設取得
    const response: OnlineReservationSettingsGetModel = await this.onlineReservationSettingsService.get(userStore);

    return response;
  }

  /**
   * ### 登録確認モーダルを表示する
   *
   * - 表示前にバリデーションチェックして、エラーならモーダルは表示しない
   */
  public async showConfirmUpdateModal(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult) {
      this.showValidationAlert = false;
      this.showUpdateModal = true;
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  /**
   * ### オンライン面会設定更新
   */
  public async updateFacility(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "更新中...";

    try {
      const updateParam: OnlineReservationSettingsPatchModel = await this.createUpdateParam();
      await this.onlineReservationSettingsService.patch(userStore, updateParam);

      this.showUpdateSuccessModal = true;
    } catch (error) {
      const systemError: SystemError = error as SystemError;
      // ステータスコードが409の場合、他端末にて更新が行われているので、画面情報を再取得してから再入力を促す
      if (systemError.statusCode == 409) {
        await this.createView();
        this.errorMessage = "他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。";
      } else {
        throw error;
      }
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 施設更新パラメータ作成
   */
  public async createUpdateParam(): Promise<OnlineReservationSettingsPatchModel> {
    const updateParam: OnlineReservationSettingsPatchModel = {
      unit: this.unit,
      availableDate: this.availableDate,
      reservationPerCounts: this.reservationPerCounts,
      countType: this.countType,
      intervalLimit: this.intervalLimit,
      visitsLimitOfMonth: this.visitsLimitOfMonth,
      concurrentNumberLimit: this.concurrentNumberLimit,
      showConcurrentNumberLimit: this.showConcurrentNumberLimit,
      limitType: this.limitType,
      canReservation: this.canReservation,
      groupUseType: this.groupUseType,
      usePublishSchedule: this.usePublishSchedule,
      publishDatetime: this.publishDatetime,
      autoApproval: this.autoApproval,
      description: this.description ? this.description : null,
      useText: this.useText,
      updated: this.updated
    };

    return updateParam;
  }

  /**
   * ### 予約一覧画面に遷移する
   */
  public gotoReservationList(): void {
    this.$router.push(PcUrl.ReservationList);

    return;
  }

  /**
   * ### 使用例モーダルを表示する
   */
  public onExampleModal(): void {
    const modal: any = this.$refs.onlineReservationSettingExampleModal;
    if (modal) {
      modal.show();
    }

    return;
  }
}
</script>

<style lang="scss" scoped>
.online-reservation-setting-tab {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;

  .example-btn {
    width: 80px;
  }
  .update-btn,
  .cancel-btn {
    width: 120px;
  }

  .box-footer {
    padding: 10px 0 0 0 !important;
  }
}
</style>
